import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  startAudit, startBatchAudit, startManualAudit, startChannelAudit,
  deleteAudit, deleteAuditProduct, reauditProduct, getCeleryStatus,
  researchCompetitors,
} from '@/lib/api/amazon-listing'
import type { CompetitorResult } from '@/lib/api/amazon-listing'

export function useStartAudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: startAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useStartBatchAudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: startBatchAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useCeleryStatus() {
  return useQuery({
    queryKey: ['celery-status'],
    queryFn: getCeleryStatus,
    staleTime: 5 * 60 * 1000,
  })
}

export function useStartManualAudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: startManualAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useStartChannelAudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: startChannelAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useDeleteAudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useDeleteAuditProduct() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteAuditProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useReaudit() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ jobId, data }: { jobId: string; data?: { report_language?: string } }) =>
      reauditProduct(jobId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['amazon-products'] })
    },
  })
}

export function useResearchCompetitors() {
  return useMutation<CompetitorResult[], Error, {
    keyword: string
    tld: string
    source_asin?: string
  }>({
    mutationFn: researchCompetitors,
  })
}
